module.exports = __webpack_public_path__ + "static/media/at.dc2457a2.svg";